export enum GatewayPendingConfigOPEEnum {
  LoadGatewayPendingConfig = 'loadGatewayPendingConfig',
  SaveGatewayPendingConfig = 'saveGatewayPendingConfig',
  ConfirmGatewayPendingConfig = 'confirmGatewayPendingConfig',
  RevertGatewayFieldsPendingConfig = 'revertGatewayFieldsPendingConfig',
  GetDevicePendingConfig = 'getDevicePendingConfig',
  SaveDevicePendingConfig = 'saveDevicePendingConfig',
  CancelDevicePendingConfig = 'cancelDevicePendingConfig',
  CancelAllDevicePendingConfig = 'cancelAllDevicePendingConfig',
  ReadGatewayPendingConfigFallback = 'readGatewayPendingConfigFallback',
  DuplicateDevicePendingConfig = 'duplicateDevicePendingConfig',
  RevertDevicePendingConfig = 'revertDevicePendingConfig',
  GetGatewayPayload = 'getGatewayPayload',
  GetGatewaysPayload = 'getGatewaysPayload'
}
